import React, { useState } from "react";

const AccordionItem = ({ title, content, className = "" }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`border-b border-gray-300 ${className}`}>
      <button
        className="w-full text-left px-4 py-3 font-bold text-black flex justify-between items-center"
        onClick={() => setIsOpen(!isOpen)}
      >
        {title}
        <span className={`transform transition-transform ${isOpen ? "rotate-180" : "rotate-0"}`}>
          ▼
        </span>
      </button>
      {isOpen && <div className="px-4 pb-3 text-gray-700">{content}</div>}
    </div>
  );
};

const Accordion = ({ items, className = "" }) => {
  if (!items || items.length === 0) return null; // Avoid rendering empty accordions

  return (
    <div className={`border w-full border-gray-300 rounded-md overflow-hidden ${className}`}>
      {items.map((item, index) => (
        <AccordionItem key={index} title={item.title} content={item.content} className={className}/>
      ))}
    </div>
  );
};

export default Accordion;
